export const surveySelectItems = [
  {
    label: "Punkte 1-10",
    value: "points",
    icon: "icon",
  },
  {
    label: "Stimme zu/nicht zu",
    value: "opinion",
    icon: "icon",
  },
  {
    label: "Smileys",
    value: "smiley",
    icon: "icon",
  },
  {
    label: "Offene Frage",
    value: "openQuestion",
    icon: "icon",
  },
  {
    label: "Dropdown-Auswahl",
    value: "select",
    icon: "icon",
  },
  {
    label: "Single Choice",
    value: "singleChoice",
    icon: "icon",
  },
  {
    label: "Multiple Choice",
    value: "multipleChoice",
    icon: "icon",
  },
];

export const CHOICE_TYPES = ["select", "singleChoice", "multipleChoice"];

export const isChoiceType = (type) => CHOICE_TYPES.includes(type);

export const getSurveyOptionFromValue = (value) => {
  return (
    surveySelectItems.find((s) => s.value === value) || {
      label: value || "Unbekannt",
      value,
    }
  );
};
